import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MomentSection } from './components/MomentSection';
import { QuotesSection } from './components/QuotesSection';
import { BookContentSection } from './components/BookContentSection';
import { WhyItMattersSection } from './components/WhyItMattersSection';
import { PricingSection } from './components/PricingSection';
import { FromTheAuthorsSection } from './components/FromTheAuthorsSection';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { SocialProofNotification } from './components/SocialProofNotification';
export function App() {
  return <div className="w-full min-h-screen bg-bttf-bg text-bttf-text" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <IntroSection data-id="element-4" />
        <TestimonialsSection data-id="element-5" />
        <MomentSection data-id="element-6" />
        <QuotesSection data-id="element-7" />
        <BookContentSection data-id="element-8" />
        <WhyItMattersSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FromTheAuthorsSection data-id="element-11" />
        <CallToAction data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <SocialProofNotification data-id="element-14" />
    </div>;
}